import React from 'react';

const Privacy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <div className="legal-content">
          <h1>
            <i className="fas fa-shield-alt"></i>
            Conditions générale de vente
          </h1>
          <p className="last-updated">Dernière mise à jour: Juin 8, 2025</p>

          <section>
            <h4>
              Conditions pour effectuer une commande Vous déclarez être âgé d'au moins 18 ans et d'avoir la capacité juridique ou d'être titulaire d'une autorisation parentale vous permettant d'effectuer une commande sur le Site.
            </h4>
          </section>

          <section>
            <h2>Droit de Rétractation :</h2>
            <p>A compter de la date de livraison de votre commande, vous disposez d'un délai de 7 jours pour faire valoir votre droit de rétractation et être intégralement remboursé ou procéder à un échange de produit. Les frais de renvoi des marchandises restant à votre charge. Cependant, seules les marchandises retournées en parfait état de revente, complètes et dans leur emballage d'origine (non-ouvert) pourront être remboursées ou échangées.</p>
          </section>

          <section>
            <h2>Délai de Rétractation :</h2>
            <p>
              Le client dispose d'un délai de 7 jours à compter de la date de livraison de la commande a fin de faire valoir son droit rétractation et être rembourser. Les frais de renvoi de la commande restent à la charge du client. Les produits retournés doivent être en parfait état dans leurs emballages d'origine et non ouverts.
            </p>
          </section>

          <section>
            <h2>Remboursement :</h2>
            <p>
              Les remboursements des produits seront effectués dans un délai inferieurs ou égal à 30 jours après la réception de la commande en bon état et non ouvert. Le remboursement s'effectuera soit par un avoir ou par échange de produit.
            </p>
          </section>

          <section>
            <h4>شروط تقديم الطلب - تقر بأن عمرك لا يقل عن 18 عامًا وأن لديك الأهلية القانونية أو أن لديك تفويضًا من الوالدين يسمح لك بتقديم طلب على الموقع.</h4>
          </section>

          <section>
            <h2>الحق في التراجع:</h2>
            <p>
من تاريخ تسليم طلبك ، لديك فترة 7 أيام لتأكيد حقك في الانسحاب ، واسترداد المبلغ بالكامل. تكاليف إعادة البضائع المتبقية على نفقتك الخاصة. ومع ذلك ، يمكن فقط استرداد البضائع المعادة بحالة ممتازة لإعادة البيع ، كاملة وفي عبواتها الأصلية (غير المفتوحة).
            </p>
          </section>

          <section>
            <h2>فترة الانسحاب :</h2>
            <p>
لدى العميل فترة 7 أيام من تاريخ تسليم الطلب لتأكيد حقه في الانسحاب والتعويض. تظل تكلفة إعادة الطلب مسؤولية العميل. يجب أن تكون المنتجات المرتجعة في حالة ممتازة في عبواتها الأصلية وغير مفتوحة.            
            </p>
          </section>
          <section>
            <h2>السداد :</h2>
            <p>
سيتم استرداد المبالغ المستردة للمنتجات في غضون فترة تقل عن 30 يومًا أو تساوي 30 يومًا بعد استلام الطلب بحالة جيدة وغير مفتوح. سيتم السداد إما عن طريق إشعار دائن أو عن طريق تبادل المنتج        
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Privacy;